import { useEffect, useRef, useState } from 'react';
import Icon from './Icon';

// "Quét QR của PT": the camera, read frame by frame with jsQR (the same on the website and in the app).
// Takes a coach QR (<site>/c/<CODE>) or a bare code and hands back the code.
export const codeFromQr = (text) => {
  const match = text.match(/\/c\/([A-Za-z]{1,6}-\d{4})/) || text.trim().match(/^([A-Za-z]{1,6}-?\d{4})$/);
  return match ? match[1].toUpperCase() : null;
};

export default function QrScanner({ onCode, onClose }) {
  const video = useRef(null);
  const [error, setError] = useState(null);
  // The camera starts once; a new onCode from the parent doesn't restart it.
  const onCodeRef = useRef(onCode);
  onCodeRef.current = onCode;

  useEffect(() => {
    let stream = null;
    let frame = null;
    let stopped = false;
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d', { willReadFrequently: true });

    const scan = async () => {
      const { default: jsQR } = await import('jsqr');
      const step = () => {
        if (stopped) return;
        const v = video.current;
        if (v && v.readyState === v.HAVE_ENOUGH_DATA) {
          canvas.width = v.videoWidth;
          canvas.height = v.videoHeight;
          context.drawImage(v, 0, 0);
          const found = jsQR(context.getImageData(0, 0, canvas.width, canvas.height).data, canvas.width, canvas.height);
          const code = found && codeFromQr(found.data);
          if (code) return onCodeRef.current(code);
        }
        frame = requestAnimationFrame(step);
        return undefined;
      };
      step();
    };

    navigator.mediaDevices?.getUserMedia({ video: { facingMode: 'environment' } })
      .then((s) => {
        stream = s;
        if (stopped) return;
        video.current.srcObject = s;
        video.current.play().catch(() => {});
        scan();
      })
      .catch(() => setError('Không mở được camera. Cho phép Macro Mate dùng camera trong Cài đặt, hoặc nhập mã bằng tay.'));
    if (!navigator.mediaDevices) setError('Trình duyệt này không mở được camera. Hãy nhập mã bằng tay.');

    return () => {
      stopped = true;
      cancelAnimationFrame(frame);
      stream?.getTracks().forEach((t) => t.stop());
    };
  }, []);

  return (
    <div role="dialog" aria-modal="true" aria-label="Quét QR của PT" className="pt-safe pb-safe fixed inset-0 z-50 flex flex-col bg-black text-white">
      <div className="flex items-center justify-between p-4">
        <span className="font-bold">Quét QR của PT</span>
        <button type="button" className="btn btn-circle size-11 border-0 bg-white/15 text-white" aria-label="Đóng" onClick={onClose}>
          <Icon name="x" className="size-5" />
        </button>
      </div>
      <div className="relative flex flex-1 items-center justify-center overflow-hidden">
        <video ref={video} playsInline muted className="absolute inset-0 size-full object-cover" />
        <div className="relative size-64 rounded-[24px] border-4 border-white/80" aria-hidden="true" />
      </div>
      <p className="p-6 text-center text-sm">{error || 'Hướng camera vào mã QR trên màn hình hoặc tấm in của PT.'}</p>
    </div>
  );
}
